import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-slate-100 py-10">
      <div className="max-w-[1100px] mx-auto px-4 grid md:grid-cols-3 gap-6 text-sm">
        
        {/* Firmeninfo */}
        <div>
          <div className="font-bold">Daraa Umzug</div>
          <p className="mt-2 text-slate-600">
            Günstige Umzüge mit studentischen Helfern.<br />
            Deutschlandweit auf Anfrage.
          </p>
        </div>

        {/* Kurz-Impressum */}
        <div>
          <div className="font-semibold">Impressum</div>
          <p className="mt-2 text-slate-600">
            Daraa Umzug<br />
            Inhaber: Mohammad Alshabani<br />
            Alt-Friedrichsfelde 68<br />
            10315 Berlin<br />
            Tel.: +49 176 41011065<br />
            E-Mail:{" "}
            <a
              href="mailto:mohammadalshabani@icloud.com"
              className="underline"
            >
              mohammadalshabani@icloud.com
            </a>
          </p>
        </div>

        {/* Rechtliches */}
        <div>
          <div className="font-semibold">Rechtliches</div>
          <ul className="mt-2 text-slate-600 space-y-1">
            <li>
              <Link to="/impressum" className="underline">
                Impressum
              </Link>
            </li>
            <li>
              <Link to="/datenschutz" className="underline">
                Datenschutz
              </Link>
            </li>
            <li>
              <Link to="/cookies" className="underline">
                Cookies
              </Link>
            </li>
            <li>
              <Link to="/agb" className="underline">
                AGB
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1100px] mx-auto px-4 mt-6 text-xs text-slate-500">
        © {new Date().getFullYear()} Daraa Umzug. Alle Rechte vorbehalten.
      </div>
    </footer>
  );
}
